"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
var tslib_1 = require("tslib");
var User = /** @class */ (function () {
    function User(userApi) {
        this.userApi = userApi;
    }
    User.prototype.isLoggedIn = function () {
        return this.userApi.currentUser.loggedIn;
    };
    User.prototype.promptLogin = function (lang) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.userApi.promptLogin({
                        lang: lang,
                    })];
            });
        });
    };
    return User;
}());
exports.User = User;
//# sourceMappingURL=User.js.map